module.exports = __webpack_public_path__ + "static/media/reportActive.51243873.svg";